import script from "./BaseChips.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChips.vue?vue&type=script&setup=true&lang=js"

import "./BaseChips.vue?vue&type=style&index=0&id=07d81a0a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d81a0a"]])

export default __exports__